import {isTransformationJob, type TypedJob} from "../../../metl-models/jobs/JobType.ts";
import type {ScoreResult} from "../model/ScoreResult.ts";

export function scorerTransformationJobUpweight(item: TypedJob): ScoreResult<TypedJob> | undefined {
    if(isTransformationJob(item)) {
        return {
            scorerId: "TRANSFORMATION_UPWEIGHT",
            score: 1,
            scoredObject: item
        }
    }
}